import {forEach as _forEach} from "lodash";
import config from '../../config';
import ActionTypes from '../../constants/ActionTypes';
import utils from '../../utils';
import interferometryDataSelectors from './selectors';


// ============ creators ===========
function ensureDataForMap(type, trackKeys, fidColumnName) {
	return (dispatch, getState) => {

		const missingDataForTracks = [];
		const promises = [];

		_forEach(trackKeys, trackKey => {
			const features = interferometryDataSelectors.getFeaturesByTypeAndTrackKey(getState(), type, trackKey);
			if (!features) {
				const url = `${config.interferometryDataRepository}/${type}/${trackKey}.json`;
				promises.push(utils.request(url, "GET", null, null));
				missingDataForTracks.push(trackKey);
			}
		});

		if (promises) {
			// the output is strictly ordered as the input as long as the input is strictly ordered
			return Promise.all(promises).then(data => {
				if (data) {
					_forEach(data, (trackData, index) => {
						const trackKey = missingDataForTracks[index];
						dispatch(actionAddByTypeByTrackKey(type, trackKey, trackData));
						dispatch(actionAddByTypeByFeatureKey(type, trackKey, fidColumnName, trackData))
					});
				}
			}).catch(err => new Error(err));
		} else {
			return Promise.resolve();
		}
	}
}

function ensureDataForPointStatistics(type, trackKey, fidColumnName, fid) {
	return (dispatch, getState) => {
		// TODO for now, request allways for data
		const url = `${config.interferometryDataRepository}/${type}/${trackKey}/${fid}.json`;
		return utils.request(url, "GET", null, null).then((data) => {
			if (data) {
				dispatch(actionAddByTypeByFeatureKey(type, trackKey, fidColumnName, data))
			}
		});
	}
}

// ============ actions ===========

const actionAddByTypeByTrackKey = (trackType, trackKey, features) => {
	return {
		type: ActionTypes.INTERFEROMETRY_DATA.ADD_BY_TYPE_BY_TRACK_KEY,
		trackType,
		trackKey,
		features
	}
};

const actionAddByTypeByFeatureKey = (trackType, trackKey, fidColumnName, features) => {
	return {
		type: ActionTypes.INTERFEROMETRY_DATA.ADD_BY_TYPE_BY_FEATURE_KEY,
		trackType,
		trackKey,
		fidColumnName,
		features
	}
};

// ============ export ===========

export default {
	ensureDataForMap,
	ensureDataForPointStatistics
}